export const MEMBER_LIST_CONTAINER = 'member-list';

/** Width from which a member row lays its identity and role out in columns. */
export const MEMBER_LIST_WIDE_MIN_WIDTH = 720;

export const MEMBER_LIST_WIDE_QUERY = `@container ${MEMBER_LIST_CONTAINER} (min-width: ${MEMBER_LIST_WIDE_MIN_WIDTH}px)`;

export const MEMBER_AVATAR_SIZE = 40;
